import { FoundResultF317CalibrationResultFormula } from './C11.formulas';

export const FoundResultSectionDataC11C13C14 = (selectedTag, formData) => ({
    rows: [{
        key: 1,
        fields: [{
            key: 'F60ToleranceEuLabel',
            value: 'Tolerance (EU)',
            xs: 2,
            width: '100%',
            readOnly: true,
            labelWidth: '0',
            height: '1.1rem',
            borderRight: '0',
            borderBottom: '0',
            marginLeft: '0.26rem',
            borderLeft: '0',
            isLabelNew: true,
            marginBottom: '4px',
            marginRight: '0',
        },
        {
            key: 'F60ToleranceEu',
            value: selectedTag.DateTested ? formData?.F60ToleranceEu : formData?.F60ToleranceEu ?? selectedTag?.ToleranceInInstrumentEu,
            maxLength: '10',
            xs: 2,
            width: '100%',
            labelWidth: '0',
            isRequired: true,
            textAlign: 'center',
            height: '1.1rem',
            borderBottom: '0',
            type: 'number',
        },
        {
            key: 'Nodata',
            xs: 4,
            height: '1.1rem',
            borderBottom: '0',
            borderRight: '0',
            borderLeft: '0',
            width: '100%',
            labelWidth: '0',
            readOnly: true
        },
        {
            key: 'F317CalibrationResultLabel',
            value: 'Calibration Result',
            width: '100%',
            readOnly: true,
            labelWidth: '0',
            height: '1.1rem',
            xs: 2,
            borderBottom: '0',
            borderRight: '0',
            borderLeft: '0',
            textAlign: 'end',
            isLabelNew: true
        },
        {
            key: 'F317CalibrationResult',
            value: FoundResultF317CalibrationResultFormula(formData),
            readOnly: true,
            isCalculatedNew: true,
            xs: 2,
            width: '100%',
            labelWidth: '0',
            textAlign: 'center',
            height: '1.1rem',
            inputMarginRight: '4px',
            borderBottom: '0',
            borderRight: '0'
        }]
    }]
});
